import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M5 9.58 1.22 7.06a.833.833 0 0 1 .14-1.46L13.443.511a.833.833 0 0 1 1.137.949l-2.544 11.448a.833.833 0 0 1-1.276.512l-2.744-1.83-1.511 2.06c-.477.65-1.506.313-1.506-.492zm5.98-6.585L2.734 6.467l2.72 1.813zM6.905 10.85l-.572.78v-1.162zm-.314-1.812 6.273-6-1.971 8.868z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }